import warehouse from 'services/warehouse';
import { bugsnagError } from 'services/bugsnag';

const setCouponBanner = payload => ({
  type: 'SET_COUPON',
  payload
});

export const updateCouponBanner = (userId) => (dispatch) => {
  return warehouse.fetchCoupon(userId)
    .then(responseData => {
      dispatch(setCouponBanner(responseData));
    }).catch(error => {
      bugsnagError(error);
    });
};
